import React, { FC } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { ProtectedRouteContainerProps, ProtectedRouteContainer } from "auth/containers/ProtectedRouteContainer";
import { getDefaultProduct } from "utils/getProducts";

/**
 * Wrapper around ProtectedRouteContainer that stores query string parameters on localstorage incase the user
 * bails on the /onboarding process.
 */
export const OnboardingProtectedRoute: FC<ProtectedRouteContainerProps> = (props) => {
    const location = useLocation();
    const history = useHistory();

    // Extract the query parameters you want to save
    const searchParams = new URLSearchParams(location.search);

    const product = searchParams.get("product") ?? (localStorage.getItem("product") || getDefaultProduct());
    const partner = searchParams.get("partner") ?? (localStorage.getItem("partner") || undefined);
    const coupon = searchParams.get("coupon") ?? (localStorage.getItem("coupon") || undefined);
    const freeTrial = searchParams.get("freeTrial") ?? (localStorage.getItem("freeTrial") || undefined);

    // If the product is present but the coupon is not, clear the coupon from local storage
    if (product && !searchParams.get("coupon")) {
        localStorage.removeItem("coupon");
    }

    if (product && !searchParams.get("partner")) {
        localStorage.removeItem("partner");
    }

    // Save them to localStorage
    if (partner) {
        localStorage.setItem("partner", partner);
    }
    if (product) {
        localStorage.setItem("product", product);
    }
    if (coupon) {
        localStorage.setItem("coupon", coupon);
    }

    if (freeTrial) {
        localStorage.setItem("freeTrial", freeTrial);
    }

    // Check if the query parameters are missing from the URL but exist in localStorage
    if (
        (partner && !searchParams.get("partner")) ||
        (product && !searchParams.get("product")) ||
        (coupon && !searchParams.get("coupon")) ||
        (freeTrial && !searchParams.get("freeTrial"))
    ) {
        // Update the URL with the query parameters from localStorage
        if (partner) {
            searchParams.set("partner", partner || "");
        }
        if (product) {
            searchParams.set("product", product || "");
        }
        if (coupon) {
            searchParams.set("coupon", coupon || "");
        }

        if (freeTrial) {
            searchParams.set("freeTrial", freeTrial || "");
        }

        history.replace({ ...location, search: searchParams.toString() });
        return null; // Render nothing while redirecting
    }

    const onboardingAuth = { pathname: `/onboarding/sign-up`, search: `${searchParams.toString()}` };
    const onboardingLogin = { pathname: "/login", search: `${searchParams.toString()}` };

    // Render the original ProtectedRoute with the same props
    return <ProtectedRouteContainer overrides={{ signUp: onboardingAuth, login: onboardingLogin }} {...props} />;
};
